import { App } from 'vue';

/**
 * Global error handler to catch and handle Vue errors gracefully
 * This prevents unhandled errors from showing in the console in production
 */
export function setupErrorHandler(app: App) {
  // Global error handler for Vue component errors
  app.config.errorHandler = (err, instance, info) => {
    // Log in development only
    if (import.meta.env.DEV) {
      console.error('Vue Error:', err);
      console.error('Component:', instance);
      console.error('Error Info:', info);
    } else {
      // In production, you might want to send to an error tracking service
      // e.g., Sentry, LogRocket, etc.
      // Example: Sentry.captureException(err);
    }
  };

  // Global warning handler (development only)
  app.config.warnHandler = (msg, instance, trace) => {
    if (import.meta.env.DEV) {
      console.warn('Vue Warning:', msg);
      console.warn('Trace:', trace);
    }
  };

  // Only add window event listeners in browser environment (not SSR)
  if (typeof window !== 'undefined') {
    // Catch unhandled promise rejections
    window.addEventListener('unhandledrejection', (event) => {
      if (import.meta.env.DEV) {
        console.error('Unhandled Promise Rejection:', event.reason);
      } else {
        // In production, log to error tracking service
        // Example: Sentry.captureException(event.reason);
      }
      event.preventDefault(); // Prevent default browser error logging
    });

    // Catch global JavaScript errors
    window.addEventListener('error', (event) => {
      if (import.meta.env.DEV) {
        console.error('Global Error:', event.error);
      } else {
        // In production, log to error tracking service
        // Example: Sentry.captureException(event.error);
      }
      event.preventDefault(); // Prevent default browser error logging
    });
  }
}
